import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.sass']
})
export class PlatformComponent implements OnInit {

  constructor(private commonService: CommonService,
    private router: Router) { }

  ngOnInit(): void {
    const routes:any = [{
      name: 'Platform Setup',
      path: 'platform-setup'
    }];
    this.commonService.setHeaderData(routes);
  }

  onPlatformItem(route:string) {
    this.router.navigate([`/${route}`]);
  }

}
